import { Color3 } from '@babylonjs/core';
import { clamp } from '@modules/standard';

import { RoomTypeData } from '../APIResponse';
import { RoomTypeResponse } from '../ecs/component/response/RoomType';

const RoomTypeColorPalette: Array<string> = [
  "#FFAB74",
  "#80A562",
  "#E1C16C",
  "#56B6AA",
  "#606ACB",
  "#60C6A2",
  "#227DC0",
  "#B288AC",
  "#6F61B0",
  "#A0D179",
  "#FF4000",
  "#32EE00",
  "#FF0059",
  "#00C9D8",
  "#0067D4",
  "#31D400",
  "#E40044",
  "#9800FF",
  "#94D400",
  "#F05000",
];

const ROOMTYPE_PALLETTE_COUNT = RoomTypeColorPalette.length;

function getBaseColorFromPalette(hex: string) {
  return Color3.FromHexString(hex);
}

function clampColor3(color: Color3) {
  color.r = Math.max(0, Math.min(1, color.r));
  color.g = Math.max(0, Math.min(1, color.g));
  color.b = Math.max(0, Math.min(1, color.b));
  return color;
}

function getRoomTypeColor(rgb1: Color3, rgb2: Color3, t: number) {
  if (!rgb1 || !rgb2) return Color3.White();

  return clampColor3(Color3.Lerp(rgb1, rgb2, t));
}

export function generateRoomTypeColor(values: RoomTypeData[]): Map<number, Color3> {
  const colors = new Map<number, Color3>();
  colors.set(0, Color3.White());

  const roomTypes = values.filter((roomtype) => !roomtype.임대여부).sort((t1, t2) => t1.공급면적.m2 - t2.공급면적.m2);
  const indexScale = Math.min(1, roomTypes.length > 0 ? ROOMTYPE_PALLETTE_COUNT / roomTypes.length : 0);
  for (let i = 0; i < roomTypes.length; i++) {
    const id = roomTypes[i]?.roomTypeId;
    if (!id) continue;
    const p = i * indexScale;
    const i0 = Math.trunc(p);
    const t = p - i0;
    const i1 = clamp(i0 + 1, 0, ROOMTYPE_PALLETTE_COUNT); // index가 pallette를 넘어서는 경우 항상 마지막 색상
    const rgb0 = RoomTypeColorPalette[i0];
    const rgb1 = RoomTypeColorPalette[i1];
    if (rgb0 && rgb1) {
      const c0 = getBaseColorFromPalette(rgb0);
      const c1 = getBaseColorFromPalette(rgb1);

      colors.set(id, getRoomTypeColor(c0, c1, t).toLinearSpace());
    }
  }

  return colors;
}
export function generateRoomTypeResponse(values: RoomTypeData[]): RoomTypeResponse[] {
  const responses = new Array<RoomTypeResponse>();
  const roomTypes = values.filter((roomtype) => !roomtype.임대여부).sort((t1, t2) => t1.공급면적.m2 - t2.공급면적.m2);
  const indexScale = Math.min(1, roomTypes.length > 0 ? ROOMTYPE_PALLETTE_COUNT / roomTypes.length : 0);
  for (let i = 0; i < roomTypes.length; i++) {
    const id = roomTypes[i]?.roomTypeId;
    const title = roomTypes[i]?.roomTypeTitle;
    if (!id || !title) continue;
    const p = i * indexScale;
    const i0 = Math.trunc(p);
    const t = p - i0;
    const i1 = clamp(i0 + 1, 0, ROOMTYPE_PALLETTE_COUNT);
    const rgb0 = RoomTypeColorPalette[i0];
    const rgb1 = RoomTypeColorPalette[i1];
    if (rgb0 && rgb1) {
      const c0 = getBaseColorFromPalette(rgb0);
      const c1 = getBaseColorFromPalette(rgb1);
      const hexColor = getRoomTypeColor(c0, c1, t).toHexString();

      responses.push({
        roomTypeId: id,
        roomTypeTitle: title,
        color: hexColor,
        active: false,
      });
    }
  }
  return responses;
}
